module.exports = __webpack_public_path__ + "img/3-2-placeholder.3dcd834b.png";